import { computed } from '@ember/object';
import ICBaseComponent from './ic-base-component';

export default ICBaseComponent.extend({
  tagName: 'thead',
  componentClasses: computed('headerPanelIsVisible', function () {
    return `table__header table__panel ${this.get('headerPanelIsVisible') ? 'o__visible' : ''}`;
  }),
});
